<template>
  <div class="ma3 ma4-l mb4">

    <!-- Если у нас договор исходящий, т.е. его смотри его создатель, то даем все возможности управления... -->
    <div v-if="out">
      <div class="template-search-layout">
        <search-select
        :options="templates"
        @input="selectTemplate"
        placeholder="Выбрать шаблон и создать документ..."
        :search-enabled="true"
        bg="dark"/>
        <template-create @save="onSave"/>
      </div>

      <div v-show="totalCount > 0" class="mt4">
        <horizontal-link-menu :items="actions" @action="actionSelected">
          <template #corner>
            <checkbox :checked="documents && documents.length === selected.size && selected.size > 0" @change="checkboxAll"/>
          </template>
        </horizontal-link-menu>
        <div>
          <async-component :params="apiParams" :asyncFunction="loadDocuments" #default="{ loading, error }">
            <div>
              <content-spinner v-if="loading" class="mv4"/>
              <div v-else-if="error" class="mv4">Ошибка: {{ error }}</div>
              <div v-else>
                <div class="list-grid">
                  <div v-for="(item, index) in documents" :key="index" class="list-item">
                    <div class="lh-copy text-line-3">
                      <!--{{ item.id }} -->
                      {{ item.title }}
                    </div>
                    <div class="flex flex-row justify-around items-center bl br b--near-white">
                      <button  @click.stop="onEdit(item)" class="input-icon-button bg-light">
                        <font-awesome-icon icon="edit" class="entity-icon"/>
                      </button>
                      <button  @click.stop="render(item)" class="input-icon-button secondary bg-light">
                        <font-awesome-icon icon="file-download" class="entity-icon"/>
                      </button>
                      <button  @click.stop="openNewEmail([item])" class="input-icon-button secondary bg-light">
                        <font-awesome-icon icon="at" class="entity-icon"/>
                      </button>
                    </div>
                    <div class="ml2 bl b--near-white">
                      <checkbox :value="item.id" :checked="selected.has(item.id)" @change="checkboxDocument"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </async-component>
        </div>
      </div>
    </div>
    <div v-else class="mt4">
      <async-component :params="apiParams" :asyncFunction="loadDocuments" #default="{ loading, error }">
        <div>
          <content-spinner v-if="loading" class="mv4"/>
          <div v-else-if="error" class="mv4">Ошибка: {{ error }}</div>
          <div v-else>
            <div class="list-grid">
              <div v-for="(item, index) in documents" :key="index" class="simple-list-item">
                <div class="lh-copy text-line-3">
                  {{ item.title }}
                </div>
                <div class="flex flex-row justify-around items-center">
                  <button  @click.stop="render(item)" class="input-icon-button secondary bg-light">
                    <font-awesome-icon icon="file-download" class="entity-icon"/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </async-component>
    </div>
    <email-form v-if="isEmailOpened" @close="closeEmail" :send="sendEmail" v-model="email"/>
  </div>
</template>

<script>
import { DataService } from '@/services/DataService.js'
import AsyncComponent from '@/components/AsyncComponent.vue'
import ContentSpinner from '@/components/common/ContentSpinner.vue'
import HorizontalLinkMenu from '@/components/common/HorizontalLinkMenu.vue'
import EmailForm from '@/components/common/email/Form.vue'
import TemplateCreate from '@/components/document_templates/Create.vue'
import SearchSelect from '@/components/ui/SearchSelect.vue'
import Checkbox from '@/components/ui/Checkbox.vue'

import useEmail from '@/composables/email'
import { download } from '@/utils/download'

export default {
  components: {
    AsyncComponent,
    ContentSpinner,
    HorizontalLinkMenu,
    TemplateCreate,
    SearchSelect,
    EmailForm,
    Checkbox
  },
  props: ['id', 'out', 'state'],
  setup (props) {
    const { email, isEmailOpened, newEmail, closeEmail, sendEmail } = useEmail()
    return {
      email,
      isEmailOpened,
      newEmail,
      closeEmail,
      sendEmail
    }
  },
  data () {
    return {
      limit: 1000,
      page: 1,
      documents: null,
      totalCount: 0,
      templates: [],
      selected: new Set([])
    }
  },
  computed: {
    apiParams () {
      return {
        contractId: +this.id,
        limit: this.limit,
        offset: (this.page - 1) * this.limit
      }
    },
    actions () {
      return [
        // { title: 'Скачать', code: 'download' },
        { title: 'Отправить', code: 'send', enabled: this.selected.size },
        { title: 'Удалить', code: 'delete', enabled: this.selected.size }
      ]
    }
  },
  methods: {
    loadDocuments (params) {
      return DataService.getDocuments(params)
        .then(({ data: { documents } }) => {
          this.documents = documents.data
          this.totalCount = documents.totalCount
        })
    },
    onSave (saved) {
      this.$router.push({ name: 'render_document', params: { contract_id: this.id, template_id: saved.id } })
    },
    onEdit (item) {
      this.$router.push({ name: 'render_document', params: { contract_id: this.id, template_id: item.templateId } })
    },
    render (item) {
      const fields = item.fields.map(({ key, value }) => ({ key, value }))

      DataService.renderDocument({ documentId: item.id, fields })
        .then(({ data: { renderDocument: { data, name } } }) => {
          download(data, name)
        })
        .catch(err => {
          console.error(err)
          this.error = 'Произошла ошибка'
        })
    },
    openNewEmail (items) {
      const files = items.map((i) => ({ id: i.id, title: i.title }))
      this.newEmail({ entity: 'CONTRACT', entityId: +this.id, files })
    },
    deleteSelectedDocuments () {
      // удаляем по-быстрому локально из списка
      this.documents = this.$lo.filter(this.documents, (d) => !this.selected.has(d.id))
      this.totalCount = this.documents.length
      const idsToDelete = Array.from(this.selected || Set.new([]))
      this.selected = new Set([])
      // делаем 'в фоне' запрос на удаление к беку
      return DataService.deleteDocuments({ contract_id: +this.id, id: idsToDelete })
        .catch(err => {
          console.error(err)
          this.error = 'Произошла ошибка'
        })
    },
    loadTemplates () {
      DataService.getDocumentTemplates({ filter: {}, limit: 1000, offset: 0 })
        .then(resp => {
          return resp
        })
        .then(({ data: { documentTemplates } }) => { this.templates = documentTemplates.data.map(({ title, id }) => ({ name: title, id })) || [] })
    },
    selectTemplate (index) {
      this.$router.push({ name: 'render_document', params: { contract_id: this.id, template_id: this.templates[index].id || index } })
    },
    checkboxDocument ({ value, checked }) {
      if (checked) {
        this.selected.add(+value)
      } else {
        this.selected.delete(+value)
      }
      // реактивность....
      this.selected = new Set(this.selected)
    },
    actionSelected (action) {
      if (!this.selected.size) return // guard
      switch (action.code) {
        case 'send':
          return this.openNewEmail(this.$lo.filter(this.documents, (d) => this.selected.has(d.id)))
        case 'delete':
          if (!confirm('Удалить документы?')) {
            return
          }
          return this.deleteSelectedDocuments()
        default:
          break
      }
    },
    checkboxAll ({ checked }) {
      if (checked) {
        this.selected = new Set(this.documents.map((d) => d.id))
      } else {
        this.selected = new Set([])
      }
    }
  },
  created () {
    this.loadTemplates()
  }
}

</script>

<style lang="scss" scoped>
.template-search-layout {
  display: grid;
  grid-template-columns: auto 130px;
  grid-template-rows: auto;
  column-gap: .5rem;
}
.list-grid {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 1fr;
  grid-gap: 1px;
  background-color: #eef2f6;
}
.list-item {
  display: grid;
  grid-template-columns: 1fr 135px 2.5rem; // c иконокой email
  // grid-template-columns: 1fr 95px 2.5rem;  // без иконки email
  grid-column-gap: .5rem;
  grid-row-gap: 1rem;
  align-items: center;
  padding: .1rem .5rem .1rem .5rem;
  background-color: #FFFFFF;
  &:hover, :focus {
    background-color: #f6f7f9;
    cursor: pointer;
  }
}
.simple-list-item {
  display: grid;
  grid-template-columns: 1fr 2.5rem;
  grid-column-gap: .5rem;
  grid-row-gap: 1rem;
  align-items: center;
  padding: .1rem .1rem .1rem .5rem;
  background-color: #FFFFFF;
  &:hover, :focus {
    background-color: #f6f7f9;
    cursor: pointer;
  }
}
</style>
